import { Box, Image, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import Layout from './Layout';
import { useNavigate, useParams } from 'react-router-dom';
import SimulateAPI from '../../api/simulate';
import { useEffect, useState } from 'react';
import { showErrorMessage } from '../../utils/apiCheck';
import { useAppDispatch } from '../../redux/hooks';
import { interviewActions } from './slice';
import { useTranslation } from 'react-i18next';
import { IS_YOUZHONG } from '../../oem';

// http://localhost:3000/simulate

function hashFunction(t, modulus = 6) {
  let hash = 0;
  if (t.length === 0) {
    return hash;
  }
  for (let i = 0; i < t.length; i++) {
    const char = t.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash % modulus); // Ensure index is within 0-8
}

const BACKGROUNDS = [
  'https://webcdn.fbmms.cn/assets/HgRR/I8FFT4Ld1JusJIQC_W1vI',
  'https://webcdn.fbmms.cn/assets/vThz/1zS1wxcxf3z7egIHCYBIU',
  'https://webcdn.fbmms.cn/assets/LLPK/3AfXIfHrFUeCo4sF0tzo1',
  'https://webcdn.fbmms.cn/assets/0MSc/nyqD508GuNDWZOQQ2WLkM',
  'https://webcdn.fbmms.cn/assets/VKxw/qP0b0333sVSwo4G2n-cOg',
  'https://webcdn.fbmms.cn/assets/BfWS/Ei7GIWHPDHIrV-bjNzFnH',
];

const BACKGROUNDS_YOUZHONG = [
  'https://webcdn.fbmms.cn/assets/rkPs/pmWrrCtBQkZY1fLwT1bxX.png',
  'https://webcdn.fbmms.cn/assets/39D0/OYNbhrCObq-5kSCJ0P8U3.png',
  'https://webcdn.fbmms.cn/assets/TCxb/pl4-LUpRGm3nsqbVcYWAN.png',
  'https://webcdn.fbmms.cn/assets/ligc/LXIqovsOZO9HS6d9Dku1i.png',
  'https://webcdn.fbmms.cn/assets/ptpU/6EHQChKNIcA_mOnbTdZLg.png',
  'https://webcdn.fbmms.cn/assets/QtSU/7VyGg6Anr7UYgQX37JNK3.png',
  'https://webcdn.fbmms.cn/assets/9-eo/wtjNc4mYLEHWhxk1NnHgA.png',
  'https://webcdn.fbmms.cn/assets/3R3I/pKXdHT9RMT37Jj7u7W6BN.png',
  'https://webcdn.fbmms.cn/assets/of8u/sFybuUvGrA4AsdDLTXpyM.png',
  'https://webcdn.fbmms.cn/assets/iX7Q/EbZyT9dHk2nN1kyp1XnzE.png',
  'https://webcdn.fbmms.cn/assets/NBP0/1g4DN46dr63gToYv7H1Ep.png',
  'https://webcdn.fbmms.cn/assets/BAfo/EXOd52kS4kP0JCVOyDZ8t.png',
];

const getBackground = (positionToken) => {
  if (IS_YOUZHONG) {
    return BACKGROUNDS_YOUZHONG[hashFunction(positionToken, 12)];
  }
  return BACKGROUNDS[hashFunction(positionToken)];
};

const EnterpriseSimulate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { type = 'list' } = useParams();
  const [keyword, setKeyword] = useState('');
  const [filteredPositions, setFilteredPositions] = useState([]);
  const [simulatePositions, setSimulatePositions] = useState(undefined);
  const [simulateRecords, setSimulateRecords] = useState([]);

  const handleSimulate = (applicationToken) => {
    navigate(`/simulate/${type}/${applicationToken}`);
  };

  const handleSimulatePostion = (positionToken) => {
    navigate(`/login/${positionToken}`);
  };

  const handleKeywordChange = (e) => {
    const { value } = e.target;
    setKeyword(value);
  };

  useEffect(() => {
    if (type === 'record') {
      setKeyword('');
    }
  }, [type]);

  useEffect(() => {
    const filtered = simulatePositions
      ?.map((v) => ({
        ...v,
        positions: v.positions.filter((vv) =>
          vv.positionName.toLowerCase().includes(keyword.toLowerCase())
        ),
      }))
      .filter((v) => v.positions.length > 0);
    setFilteredPositions(filtered);
  }, [keyword, simulatePositions]);

  useEffect(() => {
    SimulateAPI.simulatePositions()
      .then((res) => {
        setSimulatePositions(res.list);
        dispatch(
          interviewActions.setEnterprise({
            name: res.enterpriseName,
            logo: res.enterpriseLogo,
          })
        );
      })
      .catch(showErrorMessage);

    SimulateAPI.simulateApplications()
      .then((res) => {
        setSimulateRecords(res.list);
      })
      .catch(showErrorMessage);
  }, [dispatch]);

  return (
    <Layout
      simulatePositions={type === 'list' ? filteredPositions : []}
      onKeywordChange={type === 'list' ? handleKeywordChange : undefined}
      keyword={keyword}
    >
      {type === 'list' && (
        <>
          <Stack width={1096} height="100%">
            {simulatePositions !== undefined && !filteredPositions?.length && (
              <Stack
                height={1}
                spacing={10}
                sx={{
                  width: 1,
                  height: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Image
                  src="https://webcdn.fbmms.cn/assets/5i0M/QNxpCoqJkhGrml2H_yeJ0.png"
                  width={300}
                />
                <Typography variant="h6" color="textSecondary">
                  暂无相关岗位数据，可尝试调整搜索条件或查看热门岗位
                </Typography>
              </Stack>
            )}
            <Stack spacing={2}>
              {filteredPositions?.map((item) => (
                <Stack spacing={3} key={item.categoryToken}>
                  <Typography
                    pt={2}
                    variant="h6"
                    fontWeight="medium"
                    id={`${item?.categoryToken}`}
                  >
                    {item.category}
                  </Typography>
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: ' repeat(4, 1fr)',
                      gap: 3,
                      width: '100%',
                      padding: 0,
                    }}
                  >
                    {item?.positions?.map((position) => (
                      <Stack
                        onClick={() => {
                          handleSimulatePostion(position.positionToken);
                        }}
                        sx={{
                          px: 3,
                          pt: 3,
                          pb: 2,
                          cursor: 'pointer',
                          justifyContent: 'space-between',
                          height: 144,
                          borderRadius: 2,
                          // boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.16)',
                          background: `url(${getBackground(
                            position.positionToken
                          )}) no-repeat center center`,
                          backgroundSize: 'cover',
                        }}
                      >
                        <Typography variant="body1" fontWeight="medium">
                          {position.positionName}
                        </Typography>
                        <Typography variant="body2">
                          {position.categoryName}
                        </Typography>
                      </Stack>
                    ))}
                  </Box>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </>
      )}

      {type === 'record' && (
        <Stack width={1096}>
          <Stack spacing={4}>
            {simulateRecords?.map((item) => (
              <Stack spacing={3}>
                <Typography variant="h6" fontWeight="medium">
                  {item.categoryName}
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: ' repeat(4, 1fr)',
                    gap: 3,
                    width: '100%',
                    padding: 0,
                  }}
                >
                  {item.items.map((position) => (
                    <Stack
                      onClick={() => handleSimulate(position.applicationToken)}
                      sx={{
                        px: 3,
                        pt: 3,
                        pb: 2,
                        cursor: 'pointer',
                        justifyContent: 'space-between',
                        height: 172,
                        borderRadius: 2,
                        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.16)',
                        backgroundImage:
                          'linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(203, 221, 246, 1) 100%)',
                      }}
                    >
                      <Typography variant="body1" fontWeight="medium">
                        {position.positionName}
                      </Typography>
                      <Typography variant="body2" mt={4}>
                        {t('Start Tim')}：{position.postTimeFormat}
                      </Typography>
                      <Typography variant="body2">
                        {position.enterpriseName}
                      </Typography>
                    </Stack>
                  ))}
                </Box>
              </Stack>
            ))}
          </Stack>
        </Stack>
      )}
    </Layout>
  );
};

export default EnterpriseSimulate;
